import { cloudChiprApi } from "../../../../../services/cloudchipr.api";
import { RootState } from "../../../../store";
import { updateDashboardFixedCacheKey } from "../../../../../components/pages/dashboard/utils/constants/fixedCacheKeys";

const selector =
  cloudChiprApi.endpoints
    .patchUsersMeOrganisationsCurrentDashboardsByDashboardId.select;

export const updateDashboardByIdLoadingSelector = (
  state: RootState,
): boolean => {
  return !!selector(updateDashboardFixedCacheKey)(state)?.isLoading;
};
